import { Component, computed, input } from '@angular/core';
import { minusOutlineIcon, trashIcon } from "@progress/kendo-svg-icons";
import { EditSystemService } from '../edit-system.service';

@Component({
  selector: 'kart-view',
  templateUrl: './kart-view.component.html',
  styleUrl: './kart-view.component.scss'
})
export class KartViewComponent {
  constructor(public editSystem: EditSystemService) { }

  public icon = trashIcon;

  public kaartId = input.required<number>();
  public editDipSwitch = input<boolean>(false);

  // public system = input.required<HwdSysteem>()

  public kaart = computed(() => {
    let id = this.kaartId();
    let ret = this.editSystem.system()?.getKaart(id);
    return ret;
  })

  onDelete() {
    let busType = this.kaart()?.type.bus;
    if (busType == undefined) {
      return;
    }
    this.editSystem.system.update(_system => {
      if (_system != undefined) {
        _system.deleteKaart(this.kaartId(), busType);
      }
      return _system;
    });
    // this.system().deleteKaart(this.kaartId(), busType);
  }

  onDipChange(d: number) {
    let kartId = this.kaartId();
    this.editSystem.system.update(_system => {
      let kart = _system?.getKaart(kartId);
      if (kart != undefined) {
        kart.dipSwitch = d;
      }
      return _system;
    });

  }
}
